<template>
    <pendo-inactivity-modal
        :show-warning="showWarning"
        :time-remaining="timeRemaining"
        :on-continue="continueSession"
        :on-logout="logout" />
</template>

<script>
import { PendoInactivityModal } from '@pendo/components-vue3';

export default {
    name: 'InactivityModal',
    components: {
        PendoInactivityModal,
    },
    props: {
        sessionTracker: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            now: Date.now(),
            showWarning: false,
        };
    },
    computed: {
        timeRemaining () {
            const timePassed = this.now - this.sessionTracker.localLastActivityTimestamp;

            return Math.floor((this.sessionTracker.inactivityThreshold - timePassed) / 1000);
        },
    },
    watch: {
        timeRemaining (seconds) {
            if (this.showWarning && (seconds % 15 === 0 || seconds < 0)) {
                this.checkActivity();
            }
        },
    },
    created () {
        this.sessionTracker.on('inactive', () => {
            if (!this.showWarning) {
                this.startTimer();
                this.showWarning = true;
            }
        });
        this.sessionTracker.on('active', () => {
            if (this.showWarning) {
                this.closeModal();
            }
        });
    },
    beforeUnmount () {
        this.clearTimer();
    },
    methods: {
        startTimer () {
            this.now = Date.now();
            this.timer = setInterval(() => {
                this.now = Date.now();
            }, 1000);
        },
        clearTimer () {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
        async checkActivity () {
            await this.sessionTracker.checkGlobalLastActivity();
            if (this.sessionTracker.isActivityWithinThreshold) {
                this.closeModal();
            } else if (this.timeRemaining <= 0) {
                this.logout();
            }
        },
        closeModal () {
            this.showWarning = false;
            this.clearTimer();
        },
        logout () {
            this.sessionTracker.logout();
        },
        continueSession () {
            this.closeModal();
            this.sessionTracker.continueSession();
        },
    },
};
</script>
